var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-12"},[_c('v-container',[_c('v-card',[_c('EditAddComponent',{attrs:{"d":_vm.d}})],1)],1),_c('rich')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }